

export default class VoiceFileResponse  {
	Id?: string = '';
	Index: number = 0;
	Name?: string = '';
	Description?: string = '';
	IsPaid: boolean = false;
	Url?: string = '';
	FemaleUrl?: string = null;
	MaleUrl?: string = null;
	constructor(obj?: Partial<VoiceFileResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
